import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// GET /ajax/order_history/{orderId}
export const receipt = async (orderId: number) => {
  const response = await new Request().get('/ajax/order_history/' + orderId)
  return Util.Obj.keysToCamel(response.data.receipt)
}
